var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    _vm.to ? "router-link" : _vm.element,
    {
      tag: "component",
      class: [_vm.classList, _vm.variantClasses],
      attrs: {
        disabled: _vm.disabled,
        href: _vm.to
          ? typeof _vm.to === "string"
            ? _vm.to
            : _vm.to.path
          : _vm.href,
        target: _vm.target,
        to: _vm.disabled ? {} : _vm.to,
        "data-hovered": "true"
      },
      on: { click: _vm.clickWithRipple }
    },
    [
      _vm._t("iconLeft"),
      _vm._v(" "),
      _c(
        "v-typo",
        { staticClass: "button__label", attrs: { variant: _vm.labelVariant } },
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      _vm._t("iconRight"),
      _vm._v(" "),
      _vm.variant === "external"
        ? _c("v-icon", {
            staticClass: "button__icon",
            attrs: { name: "ui/external" }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }